import * as base64url from 'universal-base64url';

export default function decodeCategories(categories: string[]): string[] {
  return categories?.map((cat) => base64url.decode(cat)) ?? [];
}
